<template>
  <div>
    <vxe-toolbar size="mini" v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="handleInsert"
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="handleDelete"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="tableData"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
        activeMethod: this.activeRowMethod,
      }"
      size="mini"
      ref="ruleTable"
      :edit-rules="validRules"
      :columns="columnList"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @edit-closed="editClosedEvent"
      align="center"
      auto-resize
    >
    </vxe-grid>
    <sirui-upload
      :action="action"
      @ossSuccess="ossSuccess"
      ref="SiruiUpload"
      :data="{ ...tokenInfo }"
    ></sirui-upload>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import inputNumber from '@/components/form-item/input-number';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  // import searchTable from '@/components/form-item/search-table';
  // import dictSelect from '@/components/DictSelect';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  import API from '@/api/purchaseSalesCenter/credit/equipmentMortgage.js';
  // import BASE_API from '@/api/dataBase.js';
  // import Lad_API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill';
  // import RETURN_API from '@/api/purchaseSalesCenter/salesReturnsAndExchange';
  // import SALE_API from '@/api/purchaseSalesCenter/businessOrder.js';
  import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: false,
      },
      validateInbound: {
        type: Function,
        default: null,
      },
      currencyList: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      // inputNumber,
      // searchTable,
      // ajaxSelect,
      // dictSelect,
      // inputNumberAd,
      siruiUpload,
    },
    data() {
      return {
        action: API.IMPORT_DETAIL,
        tableData: [],
        companyCode: '',
        equipmentTypeList: [],
        repeatMortgageList: [
          { label: '是', value: 'Y' },
          { label: '否', value: 'N' },
        ],
        returnRepeatMortgageList: [
          { label: '是', value: '1' },
          { label: '否', value: '0' },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      validRules() {
        // const prefixInput = this.$t('mcInboundEdit.msg.rules.input');
        // const prefixSelect = this.$t('mcInboundEdit.msg.rules.select');
        return {
          equipmentNo: [
            {
              required: true,
              message: '请填写设备编号',
            },
          ],
          equipmentName: [
            {
              required: true,
              message: '请填写设备名称',
            },
          ],
          creditLimitAmount: [
            {
              required: true,
              message: '请填写设备担保授信限额',
            },
          ],
          creditAmount: [
            {
              required: true,
              message: '请填写授信评估金额',
            },
          ],
          purchaseYear: [
            {
              required: true,
              message: '请选择购置年份',
            },
          ],
          debtMaturityBegin: [
            {
              required: true,
              message: '请选择主债发生期限（起）',
            },
          ],
          debtMaturityEnd: [
            {
              required: true,
              message: '请选择主债发生期限（止）',
            },
          ],
          invoiceNo: [
            {
              required: true,
              message: '请填写发票号码',
            },
          ],
          equipmentType: [
            {
              required: true,
              message: '请填写设备种类',
            },
          ],
          invoiceAmount: [
            {
              required: true,
              message: '请填写发票金额（含税）',
            },
          ],
          equipmentSpec: [
            {
              required: true,
              message: '请填写规格',
            },
          ],
          repeatMortgage: [
            {
              required: true,
              message: '请选择是否重复抵押',
            },
          ],
          equipmentQuantity: [
            {
              required: true,
              message: '请填写设备台数',
            },
          ],
          equipmentSupplier: [
            {
              required: true,
              message: '请填写设备供应商',
            },
          ],
        };
      },

      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          { title: '序号', field: 'sortNo', type: 'seq', width: 60 }, //序号
          {
            title: '设备编号',
            field: 'equipmentNo',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            title: '设备名称',
            field: 'equipmentName',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            title: '设备担保授信限额',
            field: 'creditLimitAmount',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.creditLimitAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['creditLimitAmount']}
                    placeholder={'请输入发票金额（含税）'}
                    clearable={true}
                    precision={2}
                    max={9999999999}
                    min={-9999999999}
                    maxLength={6}
                    onInput={(val) => this.updateCol(row, val, 'creditLimitAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            title: '授信评估金额',
            field: 'creditAmount',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.creditAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['creditAmount']}
                    placeholder={'由管理员填写'}
                    clearable={true}
                    precision={2}
                    max={9999999999}
                    min={-9999999999}
                    maxLength={6}
                    onInput={(val) => this.updateCol(row, val, 'creditAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            title: '购置年份',
            field: 'purchaseYear',
            width: 180,
            editRender: {
              name: 'ElDatePicker',
              props: {
                type: 'year',
                clearable: true,
                format: 'yyyy',
                valueFormat: 'yyyy',
              },
              // events: {change: (obj)=>this.updateCol(obj.row,obj.row['purchaseYear'],'purchaseYear')},
            },
          },
          {
            title: '主债发生期限(起)',
            field: 'debtMaturityBegin',
            width: 180,
            editRender: {
              name: 'ElDatePicker',
              props: {
                type: 'date',
                clearable: true,
              },
            },
          },
          {
            title: '主债发生期限(止)',
            field: 'debtMaturityEnd',
            width: 180,
            editRender: {
              name: 'ElDatePicker',
              props: {
                type: 'date',
                clearable: true,
              },
            },
          },
          {
            title: '发票号码',
            field: 'invoiceNo',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            title: '设备种类',
            field: 'equipmentType',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            // editRender: {
            //   name: "ElSelect",
            //   options: this.equipmentTypeList,
            //   events: {change: (obj)=>this.updateCol(obj.row,obj.row['equipmentType'],'equipmentType')},
            //   props: {clearable:true}
            // },
          },
          {
            title: '发票金额（含税）',
            field: 'invoiceAmount',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.invoiceAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['invoiceAmount']}
                    placeholder={'请输入发票金额（含税）'}
                    clearable={true}
                    precision={2}
                    max={9999999999}
                    min={-9999999999}
                    maxLength={6}
                    onInput={(val) => this.updateCol(row, val, 'invoiceAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            title: '规格',
            field: 'equipmentSpec',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            title: '是否重复抵押',
            field: 'repeatMortgage',
            width: 150,
            editRender: {
              name: 'ElSelect',
              options: this.repeatMortgageList,
              events: {
                change: (obj) =>
                  this.updateCol(obj.row, obj.row['repeatMortgage'], 'repeatMortgage'),
              },
              props: { clearable: true },
            },
          },
          {
            title: '设备台数',
            field: 'equipmentQuantity',
            width: 100,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumnForNum(row.equipmentQuantity)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row['equipmentQuantity']}
                    placeholder={'请输入设备台数'}
                    clearable={true}
                    precision={3}
                    max={9999999999}
                    min={-9999999999}
                    maxLength={6}
                    onInput={(val) => this.updateCol(row, val, 'equipmentQuantity')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            title: '设备供应商',
            field: 'equipmentSupplier',
            width: 150,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          // {title: "设备供应商", field: "equipmentSupplier", width: 150,
          //   editRender: { name: "ElInput", props: { clearable: true},},
          //   slots: {
          //     // 使用 JSX 渲染
          //     default: ({ row }) => {
          //       return [
          //         <span>{ row.equipmentSupplier}</span>
          //       ]
          //     },
          //     edit: ({ row }) => {
          //       return [
          //         <search-table
          //           searchType="supplier"
          //           isMultiple={true}
          //           currentValue={row['equipmentSupplier']}
          //           checkRowKeys={[row['equipmentSupplier']]}
          //           onInput={val => this.updateCol(row, val, "equipmentSupplier")}
          //         ></search-table>
          //       ]
          //     }
          //   }
          // },
          {
            title: '备注',
            field: 'remark',
            width: 300,
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
    },
    mounted() {},
    watch: {
      dataMapping(val) {
        this.tableData = val;
        this.tableData.map((item) => {
          item['repeatMortgage'] = this.returnRepeatMortgageList.find(
            (it) => it.value == item.repeatMortgage
          ).label;
        });
      },
    },
    methods: {
      ossSuccess(response) {
        let list = response.data;
        list.map((item) => {
          let params = this.$baseRequest.assignObj(item);
          this.$refs.ruleTable
            .insertAt(params, -1)
            .then(({ row }) => this.$refs.ruleTable.setActiveRow(row));
        });
      },
      handleInsert() {
        this.validateInbound()
          .then(() => {
            // const userInfo = this.userInfo;
            let params = {};
            params = this.$baseRequest.assignObj(params);
            this.$refs.ruleTable
              .insertAt(params, -1)
              .then(({ row }) => this.$refs.ruleTable.setActiveRow(row));
          })
          .catch(() => {
            console.log('handleInsertErr');
          });
      },
      activeRowMethod() {
        //禁用编辑
        console.log(this.canEdit);
        return this.canEdit;
      },
      //JSX更新字段
      updateCol(row, val, type) {
        row[type] = val;
      },

      editClosedEvent(row) {
        console.log(row);
      },
      updateRow(row, obj) {
        row.invoiceAmount = obj.invoiceAmount;
        row.excludedTaxAmount = obj.excludedTaxAmount;
        row.taxAmount = obj.taxAmount;
        row.invoiceAccountedAmount = obj.invoiceAccountedAmount;
        row.excludedTaxAccountedAmount = obj.excludedTaxAccountedAmount;
        row.taxAccountedAmount = obj.taxAccountedAmount;
        row.ladingDifferenceAmount = obj.ladingDifferenceAmount;
        row.recoverableTaxAmount = obj.recoverableTaxAmount;
      },
      getValues() {
        const allData = this.$refs['ruleTable'].getTableData();
        const tableData = allData.tableData;
        return tableData.map((item, index) => {
          const result = Object.assign({}, item, {
            invoiceDetailCode: item.invoiceDetailCode || index + 1,
          });
          return result;
        });
      },
      //抛出表格数据
      exportTableData() {
        let detailList = this.$refs.ruleTable.getTableData().fullData;
        return detailList;
      },
      handleDelete() {
        const selectedList = this.$refs['ruleTable'].getCheckboxRecords(); // 选中数据
        console.log(selectedList);
        console.log(selectedList.length);
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        let msg = '是否确认删除';
        this.$confirmAction(msg)
          .then(() => {
            this.$refs['ruleTable'].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('message.success'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('message.cancle'),
            });
          });
      },
      // 生成校验规则
      getRules() {
        const emptyTip = this.$t('contractAgency.productTab.emptyTip');
        const rules = {};
        this.columnsList.forEach((item) => {
          const required = typeof item.required === 'function' ? item.required() : item.required;
          if (required) {
            const title = this.$t('saleInvoice.' + (item.otherKey || item.field));
            const message = title + emptyTip;
            rules[item.field] = [{ required: true, message: message }];
          }
        });
        return rules;
      },
      // 币种格式转换
      fotmatCurrency({ cellValue }) {
        console.log(cellValue);
        if (cellValue)
          return this.currencyList.find((it) => it.currencyCode == cellValue).currencyName;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .price-col {
    line-height: 18px;
  }
</style>
